module.exports = __webpack_public_path__ + "img/ext1.37fd0db8.png";